import { StrictMode } from 'react'
import "./utils/stringUtils/prototypes.ts";
import { createRoot } from 'react-dom/client'
import App from './App'
import { Suspense } from "react";
import "./assets/styles/main.less";
import PageSpinner from "./components/PageSpinner/PageSpinner";
import store from "./store/app";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import { StyleProvider } from "@ant-design/cssinjs";
import React from 'react';

createRoot(document.getElementById('root')!).render(
   <Suspense fallback={<PageSpinner />}>
    <Provider store={store}>
      <StyleProvider hashPriority="high">
        <ConfigProvider theme={{ hashed: false }}>
          <App />
        </ConfigProvider>
      </StyleProvider>
    </Provider>
  </Suspense>,
)
